<template>
  <v-container fluid>
    <div class="error" v-if="error">
      <p>{{ error }}</p>
    </div>

    <div class="form">
      <InputField
        :labelStyles="{ color: '#00A9B3', margin: '0 0 0 16px' }"
        :inputStyles="{ border: 0, margin: 0 }"
        :placeholder="$t('dash.dictionary.article.form-title')"
        v-model="entry.title"
        :labelTitle="$t('dash.dictionary.article.form-title-placeholder')"
        style="margin-bottom: 16px; margin-top: 16px"
      />
      <TextAreaField
        :labelStyles="{ color: '#00A9B3', margin: '0 0 0 16px' }"
        :inputStyles="{ border: 0, margin: 0 }"
        class="input"
        v-model="entry.description"
        :labelTitle="$t('dash.dictionary.article.form-desc')"
        :placeholder="$t('dash.dictionary.article.form-desc-placeholder')"
        rows="3"
        style="margin-bottom: 16px"
      />

      <div v-if="files.length > 0" class="uploads">
        <div
          @click="removeUploadFromList(file)"
          v-for="file in files"
          :key="file.id"
          class="upload-container"
        >
          <img
            :id="`file${file.name}-preview`"
            class="upload-preview"
            :alt="file.name"
          />
        </div>
      </div>
      <div v-if="entry.uploads.length > 0" class="uploads">
        <div
          @click="removeAddedUploads(upload)"
          v-for="upload in entry.uploads"
          :key="upload.id"
          class="upload-container"
        >
          <img
            :src="upload.blobUri"
            class="upload-preview"
            :alt="upload.originalname"
          />
        </div>
      </div>

      <TagSelector :tags="tags" @selection-changed="tagSelectionChanged" />

      <AddedTags
        :tags="entry.tags"
        @tag-deleted="
          id => (entry.tags = entry.tags.filter(e => e.id !== id))
        "
      />

      <ListItem :last="true" icon="camera-blue.svg">
        <Upload @fileSelect="fileSelect" :label="$t('general.post.upload')" />
      </ListItem>
    </div>
    <LoadingButton v-if="loading" style="margin: 16px 0"></LoadingButton>
    <div v-else>
      <Button
        v-if="!this.entry.id"
        @click.native="writeEntry('add')"
        :title="$t('dash.dictionary.article.action-add')"
        style="margin: 16px 0"
      />
      <Button
        v-else
        @click.native="writeEntry('edit')"
        :title="$t('dash.dictionary.article.action-save')"
        style="margin: 16px 0"
      />
    </div>
  </v-container>
</template>

<script>
import {
  neoparentCategories,
  neoparentTags,
  neoparentDictionaryEntries, neoparentUploads
} from "@/api";
import { setImgPreview, uploadFile } from "@/helpers";
import { redirect } from "../../helpers";

export default {
  name: "neoparent-create-lexicon-entry",
  components: {},
  data() {
    return {
      tags: [],
      files: [],
      loading: false,
      error: "",
      categoryId: new URL(window.location).searchParams.get("categoryId"),
      category: null,
      editId: new URL(window.location).searchParams.get("entryId"),
      entry: {
        title: null,
        description: null,
        uploads: [],
        tags: []
      }
    };
  },
  mounted() {
    neoparentTags
      .getTags()
      .then(result => {
        this.consoleLog(result);
        this.tags = result.data.tags;
      })
      .catch(err => {
        this.consoleLog(err);
      });
    if (this.editId) {
      neoparentDictionaryEntries
        .getAll("")
        .then(result => {
          this.consoleLog(result);
          this.entry = result.data.entries.find(x => x.id === this.editId);
          if (!this.entry.categoryId) {
            redirect("/dashboard/dictionary");
          }
        })
        .catch(err => {
          this.consoleLog(err);
        });
    }
    if (this.categoryId) {
      neoparentCategories
        .getCategories()
        .then(result => {
          this.consoleLog(result);
          this.category = result.data.find(x => x.id === this.categoryId);
        })
        .catch(err => {
          this.consoleLog(err);
        });
    } else {
      redirect("/dashboard/dictionary");
    }
  },
  methods: {
    tagSelectionChanged: function(e) {
      const tag = JSON.parse(e.target.getAttribute("data-value"));

      if (!this.entry.tags.find(e => tag.id === e.id)) {
        // no duplicates
        this.entry.tags.push(tag);
      }
    },
    async writeEntry(action) {
      if (action !== "add" && action !== "edit") return;

      if (this.entry.title !== "" && this.entry.description !== "") {
        this.loading = true;

            if (this.files.length > 0) {
              for (const file of this.files) {
                file.access = "pub";

                const formData = new FormData()
                formData.append("file", file, file.name)
                formData.append("access", file.access)
                formData.append("mimeType", file.type)

                const res = await neoparentUploads.uploadFile(formData)
                this.entry.uploads.push(res.data.data);
              }
            }

        let data = {
          id: this.entry.id,
          category: this.category,
          title: this.entry.title,
          description: this.entry.description,
          tags: this.entry.tags,
          uploads: this.entry.uploads
        };
        this.consoleLog(data);

        if (action === "add") {
          // Create new
          this.consoleLog("Creating entry");

          neoparentDictionaryEntries
            .addEntry(data)
            .then(result => {
              this.consoleLog(result);
              this.loading = false;
              redirect("/dashboard/dictionary");
            })
            .catch(err => {
              this.consoleLog(err);
              window.scrollTo(0, 0);
              this.loading = false;
              this.error = this.$t("error.dictionary.category.missing-title");
            });
        } else {
          neoparentDictionaryEntries
            .editEntry(this.entry.id, data)
            .then(result => {
              this.consoleLog(result);
              this.loading = false;
              redirect("/dashboard/dictionary");
            })
            .catch(err => {
              this.consoleLog(err);
              window.scrollTo(0, 0);
              this.loading = false;
              this.error = this.$t("error.dictionary.category.missing-title");
            });

          this.consoleLog("Updating entry");
        }
      } else {
        this.error = this.$t("error.dictionary.article.title-desc");
        window.scrollTo(0, 0);
      }
    },
    fileSelect(fileList) {
      if (
        fileList.length + this.entry.uploads.length > 5 ||
        this.files.length + fileList.length + this.entry.uploads.length > 5
      ) {
        this.error = this.$t("error.dictionary.upload.max");
        window.scrollTo(0, 0);
      } else {
        this.consoleLog(fileList);
        this.files.push(...fileList);
        this.files = this.files.filter(file => {
          return file.type.includes("image/") || file.type.includes("video/");
        });
        this.files.forEach(file => {
          setImgPreview(`file${file.name}-preview`, file);
        });
      }
    },
    removeUploadFromList(file) {
      if (confirm(this.$t("dash.dictionary.article.upload-confirm"))) {
        this.files.splice(this.files.indexOf(file), 1);
      }
      this.files.forEach(file => {
        setImgPreview(`file${file.name}-preview`, file);
      });
    },
    removeAddedUploads(upload) {
      if (confirm(this.$t("dash.dictionary.article.upload-confirm"))) {
        this.entry.uploads.splice(
          this.entry.uploads.indexOf(upload),
          1
        );
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tags {
  display: flex;
  flex-wrap: wrap;
  padding: 1rem;
}
</style>
